import { RepeatTemplateTaskData } from "../../Types/Types";
import getNextDayOfWeek from "../../utils/getNextDayOfWeek";
import { regExpAfterTomorrow, regExpDaysOfWeek, regExpDifferentDay, regExpGroups, regExpNextMonth, regExpNextWeek, regExpNextYear, regExpNoDate, regExpToday, regExpTomorrow } from "./regularExpForTime";

type useDataRecognitionFunctions = {
    setDataRecognitions: () => void;
}

interface dataArrWeekDays {
    dayId: string,
    dayMatches: {
        full: string,
        full2: string,
        full3: string,
        short: string,
        short2nd: string
    }
}

interface dataOptionsRepitPeriod {
    pereiodId: number,
    periodVariant: string
}

// repitPeriod: 5,
// selectedWeekDays: "1, 2, 3, 4, 5, 6, 0",
// intervalType: 1

const useSetDataRecognition = (
    spanElements: Element[], 
    setPriority: Function,
    updateRepeatTemplate: Function,
    setDate: Function,
    setTime: Function,
    setTaskHours: Function,
    setTaskMinutes: Function, 
    selectedValues: {
        priority: number | null,
        time: string | null,
        date: string | Date | null ,
        timeToTaskHours: string | null,
        timeToTaskMinutes: string | null,
        repeatTemplate?: RepeatTemplateTaskData
    }, datePayload: Date | null ): useDataRecognitionFunctions =>  {
    
    const arrMonth = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 
                        'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    const arrMonthCutted = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    const arrPriority = ['!!1', '!!2', '!!3', '!!0'];
    const optionArr1: dataOptionsRepitPeriod[] = [
        {pereiodId: 0, periodVariant: 'не повторять'},
        {pereiodId: 1, periodVariant: 'каждый день'},
        {pereiodId: 3, periodVariant: 'каждый месяц'},
        {pereiodId: 3, periodVariant: 'ежемесячно'},
        {pereiodId: 4, periodVariant: 'по будням'},
    ]
    const arrWeekDays: dataArrWeekDays[] = [
        {dayId: '1', dayMatches: {full: 'понедельник', full2: '', full3: 'в понедельник', short: 'пн', short2nd: 'в пн'}},
        {dayId: '2', dayMatches: {full: 'вторник', full2: '', full3: 'во вторник', short: 'вт', short2nd: 'во вт'}},
        {dayId: '3', dayMatches: {full: 'среду', full2: 'среда', full3: 'в среду', short: 'ср', short2nd: 'в ср'}},
        {dayId: '4', dayMatches: {full: 'четверг', full2: '', full3: 'в четверг', short: 'чт', short2nd: 'в чт'}},
        {dayId: '5', dayMatches: {full: 'пятницу', full2: 'пятница', full3: 'в пятницу', short: 'пт', short2nd: 'в пт'}},
        {dayId: '6', dayMatches: {full: 'субботу', full2: 'суббота', full3: 'в субботу', short: 'сб', short2nd: 'в сб'}},
        {dayId: '0', dayMatches: {full: 'воскресенье', full2: '', full3: 'в воскресенье', short: 'вс', short2nd: 'в вс'}}
    ]

    const dateСomparison = (dateOfMonth: Date, currentDate: Date) => {
        let date1 = Date.UTC(dateOfMonth.getFullYear(), dateOfMonth.getMonth(), dateOfMonth.getDate())
        let date2 = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
        if (date1 > date2) {
            return date1 > date2
        } else if (date1 === date2) {
            return date1 === date2
        }
    }

    const returnPositionInArray = (matchedItem: string): number | null => {
        const getIndex = optionArr1.find(el => el.periodVariant === matchedItem.toLowerCase());
        if (getIndex === undefined) {
            return null
        }
        return getIndex.pereiodId
    }

    const selectOfDate = (text: string, currentDate: Date) => {        
        for (const regExp of regExpGroups.Date) {
            switch (regExp) {
                case regExpTomorrow:
                    if (text.match(regExp)) {
                        let tomorrow = new Date(currentDate)
                        tomorrow.setDate(tomorrow.getDate() + 1).toLocaleString()
                        setDate(tomorrow.toLocaleDateString())
                    }
                    break;
                case regExpToday:
                    if (text.match(regExp)) {
                        setDate(currentDate.toLocaleDateString())
                    }
                    break;
                case regExpAfterTomorrow:
                    if (text.match(regExp)) {
                        let afterTomorrow = new Date(currentDate)
                        afterTomorrow.setDate(afterTomorrow.getDate() + 2)
                        setDate(afterTomorrow.toLocaleDateString())
                    }
                    break;
                case regExpNoDate:
                    if (text.match(regExp)) {
                        setDate('')
                    }
                    break;
                case regExpNextWeek:
                    if (text.match(regExp)) {
                        const newDate = new Date(currentDate.getFullYear(), 
                                                currentDate.getMonth(), 
                                                currentDate.getDate() + 7)
                        setDate(newDate.toLocaleDateString())
                    }
                    break;
                case regExpNextMonth:
                    if (text.match(regExp)) {
                        const newDate = new Date(currentDate.getFullYear(), 
                                                currentDate.getMonth() + 1, 
                                                currentDate.getDate())
                        setDate(newDate.toLocaleDateString())
                    }
                    break;
                case regExpNextYear:
                    if (text.match(regExp)) {
                        const newDate = new Date(currentDate.getFullYear() + 1, 
                                                currentDate.getMonth(), 
                                                currentDate.getDate())
                        setDate(newDate.toLocaleDateString())
                    }
                    break;
                case regExpDaysOfWeek: 
                    if (text.match(regExp)) {                        
                        arrWeekDays.forEach((el: dataArrWeekDays) => {
                            if (el.dayMatches.full.match(text) || el.dayMatches.full2.match(text) || el.dayMatches.full3.match(text) || el.dayMatches.short.match(text)) {
                                setDate(getNextDayOfWeek(currentDate, Number(el.dayId)).toLocaleDateString())
                            }
                        })
                    }
                    break;
                case regExpDifferentDay:
                    if (text.match(regExp)) {
                        let cuttedDay = text.split(' ')
                            arrMonth.map(month => {
                                if (cuttedDay[1] === month) {
                                    const newDate = new Date(currentDate.getFullYear(), 
                                                            arrMonth.indexOf(month), 
                                                            Number(cuttedDay[0]))
                                    if (dateСomparison(newDate, currentDate)) {
                                            return setDate(newDate.toLocaleDateString())
                                    } else {
                                        const newDateFuture = new Date(currentDate.getFullYear() + 1, 
                                                                        arrMonth.indexOf(month), 
                                                                        Number(cuttedDay[0]))
                                        return setDate(newDateFuture.toLocaleDateString())
                                    }
                                } else {
                                    return 0
                                }
                            })
                            arrMonthCutted.map(month => {
                                if (cuttedDay[1] === month) {
                                    const newDate = new Date(currentDate.getFullYear(), 
                                                            arrMonthCutted.indexOf(month), 
                                                            Number(cuttedDay[0]))
                                    if (dateСomparison(newDate, currentDate)) {
                                            return setDate(newDate.toLocaleDateString())
                                        
                                    } else {
                                        const newDateFuture = new Date(currentDate.getFullYear() + 1, 
                                                                        arrMonthCutted.indexOf(month), 
                                                                        Number(cuttedDay[0]))
                                        return setDate(newDateFuture.toLocaleDateString())
                                    }
                                } else {
                                    return 0
                                }
                            })
                    }
                    break;
            }
        }
    }    
    
    const setDataRecognitions = () => {
        const currentDate =  datePayload === null ? new Date() : datePayload
        for (const [groupName] of Object.entries(regExpGroups)) {
            const getArrGroup = spanElements.filter(el => el.getAttribute('data-match-group') === groupName)
            switch (groupName) {
                case "TimeHours":
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')?.getAttribute('data-match-id') ?? ''
                        const reg: RegExp =  /([0-1]?[0-9]|2[0-3])/gi
                        const splited = elem.match(reg)
                        if (splited) {
                            setTaskHours(splited)   
                        }
                    } 
                    // else {
                    //     setTaskHours(selectedValues.timeToTaskHours ?? '')
                    // }
                    break;
                case "TimeMinutes":
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')?.getAttribute('data-match-id') ?? ''
                        const reg: RegExp = /([0-5]?[0-9])/gi
                        const splited = elem.match(reg);                        
                        setTaskMinutes(splited)
                    } 
                    // else {
                    //     setTaskMinutes(selectedValues.timeToTaskMinutes ?? '')
                    // }
                    break;
                case 'TaskPriority':
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')
                        setPriority(arrPriority.indexOf(elem?.getAttribute('data-match-id') ?? ''));
                    } else {
                        setPriority(selectedValues.priority ?? 3)
                    }
                    break;
                case 'Date':
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')
                        selectOfDate(elem?.getAttribute('data-match-id') ?? '' , currentDate)
                    } 
                    // else {
                    //     setDate(selectedValues.date ?? currentDate.toLocaleDateString())
                    // }
                    break;
                case 'TaskTime':
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')?.getAttribute('data-match-id') ?? ''
                        const splited = elem.split(' ')                         
                        if (splited.length > 1) {
                            if (splited[1].includes(':')) {
                                setTime(splited[1])
                            } else {
                                setTime(`${splited[1]}:00`)
                            }
                        } else {
                            setTime(splited[0])
                        } 
                    } 
                    // else {
                    //     setTime(selectedValues.time ?? '')
                    // }
                    break;
                case 'FullDate':
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')?.getAttribute('data-match-id') ?? ''
                        for (const regExp of regExpGroups.Date) {
                            const match = elem.match(regExp)
                            if (match) {
                                selectOfDate(match[0], currentDate)
                            }
                        }
                        for (const regExp of regExpGroups.TaskTime) {
                            const match = elem.match(regExp)
                            if (match) {
                                const splited = match[0].split(' ')
                                if (splited.length > 1) {
                                    setTime(splited[1])
                                } else {
                                    setTime(splited[0])
                                } 
                            }
                        }
                    } else {
                        setDate(selectedValues.date ?? datePayload === null ? '' : datePayload.toLocaleDateString())
                        setTime(selectedValues.time ?? '')
                    }
                    break;
                case 'FullTime':
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')?.getAttribute('data-match-id') ?? ''
                        const reg = new RegExp('[0-9]{1,2}')
                        for (const regExp of regExpGroups.TimeHours) {
                            const match = elem.match(regExp)
                            if (match) {
                                const matchSplit = match[0].match(reg)
                                setTaskHours(matchSplit![0])
                            }
                        }
                        for (const regExp of regExpGroups.TimeMinutes) {
                            const match = elem.match(regExp)
                            if (match) {
                                const matchSplit = match[0].match(reg)
                                setTaskMinutes(matchSplit![0])            
                            }
                        }
                            
                    } else {
                        setTaskMinutes(selectedValues.timeToTaskMinutes ?? '')
                        setTaskHours(selectedValues.timeToTaskHours ?? '')
                    }

                    break;
                case 'TaskRepeat':
                    if (getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')) {
                        const elem = getArrGroup.find(el => el.getAttribute('data-tracking') === 'true')?.getAttribute('data-match-id') ?? ''
                        for(const regExp of regExpGroups.TaskRepeat) {
                            const match = elem.match(regExp)
                            if (match) {
                                const getPeriod = returnPositionInArray(match[0] ?? '')
                                if (getPeriod === 4) {
                                    const getDay = currentDate.getDay();
                                    const dateToSet = new Date(currentDate);
                                    if (getDay === 0) {
                                        dateToSet.setDate(dateToSet.getDate() + 1)
                                        setDate(dateToSet.toLocaleDateString())
                                    } else if (getDay === 6) {
                                        dateToSet.setDate(dateToSet.getDate() + 2)
                                        setDate(dateToSet.toLocaleDateString())
                                    }
                                    updateRepeatTemplate('repitPeriod', 4)                   
                                } 
                                if (getPeriod === null) {
                                    if ((match[0].toLocaleLowerCase() === 'конец месяца') || 
                                            match[0].toLocaleLowerCase() === 'последний день месяца') {
                                        updateRepeatTemplate('repitPeriod', 5);
                                        updateRepeatTemplate('intervalType', 2);
                                        updateRepeatTemplate('selectedMonthDays', '0');
                                        return
                                    }
                                    let getDataOfWeek = arrWeekDays.find(el => {
                                        if (match[0].toLowerCase().match(el.dayMatches.full) || 
                                                match[0].toLowerCase().match(el.dayMatches.short)) {
                                            return el.dayId
                                        } else {
                                            return 0
                                        }
                                    });
                                    if (getNextDayOfWeek(currentDate, Number(getDataOfWeek?.dayId)).toLocaleDateString() === currentDate.toLocaleDateString()) {
                                        updateRepeatTemplate('repitPeriod', 2)
                                    } else {
                                        updateRepeatTemplate('repitPeriod', 5);
                                        updateRepeatTemplate('intervalType', 1);
                                        updateRepeatTemplate('selectedWeekDays', getDataOfWeek?.dayId)
                                    }
                                    setDate(getNextDayOfWeek(currentDate, Number(getDataOfWeek?.dayId)).toLocaleDateString())
                                } else {
                                    updateRepeatTemplate('repitPeriod', getPeriod)
                                }
                            }
                        }                        
                    } else {                        
                        // const date = new Date()
                        updateRepeatTemplate('repitPeriod', 0);
                        updateRepeatTemplate('intervalType', 0);
                        updateRepeatTemplate('selectedWeekDays', null);
                        updateRepeatTemplate('selectedMonthDays', null)
                        // selectOfDate( '' , currentDate)
                        // setDate(currentDate.toLocaleDateString())
                        // setTimeout(() => {
                        //     setDate(selectedValues.date ?? datePayload === null ? date.toLocaleDateString() : datePayload.toLocaleDateString())
                        // }, 100);
                    }
                    break;
                default:
                    break;
            }   
        }
    }
    return {setDataRecognitions}
}

export default useSetDataRecognition